<template>
    <section class="section section-yellow section-products">
        <div class="container">
            <h2 class="mb-1">
                {{ $t('home.chooseFrom', [40]) }}
            </h2>

            <samples-list />
        </div>
    </section>
</template>

<script>
import SamplesList from "./SamplesList.vue";

export default {
  name: "Samples",

  components: {
    SamplesList,
  },
};
</script>
